import React, { useEffect, useState, useContext } from 'react';
import * as XLSX from 'xlsx';
import Notify from '@shared/notify';
import Modal from 'react-bootstrap/Modal';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import moment from 'moment';
import Button from 'react-bootstrap/Button';
import { AuthContext } from '@shared/context/AuthContext';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import APIService from '@shared/services/api';

const BulkUpload = (props: any) => {
    const { setLoader, setProgress, setProgressType, setDemandStatus }: any = useContext(AuthContext);
    const [recordCount, setRecordCount] = useState(null);
    const [uploadTrue, setUploadTrue] = useState(false);
    const [location, setLocation] = useState([]);
    const [materialType, setmaterialType] = useState(['solid', 'liquid', 'gas']);
    const [unitType, setUnitType] = useState([
        'milligram',
        'gram',
        'pound',
        'kilogram',
        'metric ton',
        'milliliter',
        'litre',
        'cubic meter',
        'millimeter',
        'inch',
        'feet',
        'meter',
        'kilometer',
        'mile',
        'watt',
        'kilowatt',
        'megawatt',
        'gigawatt',
        'milliwatt',
        'number',
    ]);
    const [pincodes, setpincodes] = useState([]);
    const [usersData, setUsersData] = useState([]);
    const [showHideUploadBtn, setshowHideUploadBtn] = useState(false);
    const [list, setList] = useState([]);
    const [upfile, setupFile] = useState('');
    const [categories, setCategories] = useState([]);
    const [loaderstate, setLoaderState] = useState(false);
    const ITEM_UNIT = {
        MASS: {
            key: 'mass',
            value: ['Milligram', 'Gram', 'Pound', 'Kilogram', 'Metric Ton'],
        },
        VOLUME: {
            key: 'volume',
            value: ['Milliliter', 'Litre', 'Cubic Meter'],
        },
        LENGTH: {
            key: 'length',
            value: ['Millimeter', 'Inch', 'Feet', 'Meter', 'Kilometer', 'Mile'],
        },
        ENERGY: {
            key: 'energy',
            value: ['Watt', 'Kilowatt', 'Megawatt', 'Gigawatt', 'Milliwatt'],
        },
        PIECES: {
            key: 'pieces',
            value: ['Number'],
        },
    };

    useEffect(() => {
        setCategories(props.category);
    }, [props.category]);

    useEffect(() => {
        try {
            const cities = (props?.locationData || []).map(i => i.city.toLowerCase());
            const pincode = (props?.locationData || []).map(i => i.pincode.toString());
            setLocation(cities);
            setpincodes(pincode);
        } catch (error) { }
    }, [props?.locationData]);

    useEffect(() => {
        const phoneNo = (props?.userData || []).map(i => i.phone);
        setUsersData(phoneNo);
    }, [props?.userData]);

    const handlefile = (e: any) => {
        try {
            setLoaderState(true);

            const files = e.target.files;
            if (files && files.length > 0) {
                const file = files[0];
                if (
                    checkFileExtension(file.name, 'csv') ||
                    checkFileExtension(file.name, 'xlsx') ||
                    checkFileExtension(file.name, 'xls')
                ) {
                    fileReader(e);
                } else {
                    Notify('error', 'Invalid file. Accept only xlsx, xls, CSV');
                }
            }
        } catch (error) { }
    };

    const checkFileExtension = (filename, extension) => {
        const regex = new RegExp('\\.' + extension + '$', 'i');
        return regex.test(filename);
    };

    const fileReader = (eFile: any) => {
        try {
            const file = eFile.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = async (e: any) => {
                    const data = e.target.result;
                    const workbook = XLSX.read(data, {
                        type: 'binary',
                        // cellDates: true
                    });
                    const sheetName = workbook.SheetNames[0]; // Assuming the data is in the first sheet
                    const worksheet = workbook.Sheets[sheetName];
                    // Assuming the data starts from A2 (skip the header)
                    const records: any = XLSX.utils.sheet_to_json(worksheet, { raw: false }); //{ header: 1, range: 1 }
                    const rLength = records.length;
                    const maxSize = 4 * 1024 * 1024; // 4MB in bytes

                    if (rLength === 0) {
                        setLoader(false);
                        return Notify('error', 'No records found in sheet');
                    } else if (rLength > 2000) {
                        setLoader(false);
                        return Notify('error', 'Allow only 1000 records at once');
                    } else if (file.size > maxSize) {
                        setLoader(false);
                        return Notify('error', 'Allow only max 4MB file');
                    } else {
                        const res: any = await dataValidation(records);

                        setLoaderState(false);
                        setUploadTrue(true);
                        setList(res.records || []);
                        setshowHideUploadBtn(res?.isValid || false);
                        if (res?.isValid && res.records?.length > 0) {
                            setupFile(file);
                        }
                    }
                };
                reader.readAsBinaryString(file);
            }
        } catch (error) { }
    };

    const dataValidation = (records: any) => {
        return new Promise((resolve, reject) => {
            try {
                if (records?.length > 0) {
                    dataValidationFn(records, 0, true, res => {
                        resolve(res);
                    });
                } else {
                    resolve(records);
                }
            } catch (error) { }
        });
    };

    const checkCategory = value => {
        const data = categories.filter((item: any, index) => {
            return (
                item.name.toLowerCase() ===
                value
                    .toString()
                    .trim()
                    .toLowerCase()
            );
        });

        if (data.length > 0) {
            return false;
        }
        return true;
    };

    const checkItem = value => {
        const data: any = categories.filter((item: any, index) => {
            return (
                item.name.toLowerCase() ===
                value.category
                    .toString()
                    .trim()
                    .toLowerCase()
            );
        });

        if (data.length > 0) {
            const itemdata = data[0].items.filter((item: any, index) => {
                return (
                    item.name.toLowerCase() ==
                    value.item
                        .toString()
                        .trim()
                        .toLowerCase()
                );
            });
            if (itemdata.length > 0) {
                return false;
            }
        }
        return true;
    };
    const checkUnit = value => {
        const data: any = categories.filter((item: any, index) => {
            return (
                item.name.toLowerCase() ===
                value.category
                    .toString()
                    .trim()
                    .toLowerCase()
            );
        });

        if (data.length > 0) {
            const itemData = data[0].items.filter((item: any, index) => {
                const itemNameMatches =
                    item.name.toLowerCase() ===
                    value.item
                        .toString()
                        .trim()
                        .toLowerCase();

                // Check if the value's itemUnit is present in the ITEM_UNIT object for the given type
                const validUnits = ITEM_UNIT[item.type.toUpperCase()]?.value.map(unit =>
                    unit
                        .toString()
                        .trim()
                        .toLowerCase(),
                );
                const isUnitMatch =
                    validUnits &&
                    validUnits.includes(
                        value.itemUnit
                            .toString()
                            .trim()
                            .toLowerCase(),
                    );

                // Return true if the name, type, and unit match
                return itemNameMatches && isUnitMatch;
            });
            if (itemData.length > 0) {
                return false;
            }
        }
        return true;
    };
    const checkUser = value => {
        const data: any = categories.filter((item: any, index) => {
            return (
                item.name.toLowerCase() ===
                value.category
                    .toString()
                    .trim()
                    .toLowerCase()
            );
        });
        if (data.length > 0) {
            const itemdata = data[0].items.filter((item: any, index) => {
                return (
                    item.name.toLowerCase() ===
                    value.item
                        .toString()
                        .trim()
                        .toLowerCase()
                );
            });
            if (itemdata.length > 0) {
                const arr: any = [];
                const d = value.users
                    .toString()
                    .split(',')
                    .map(i => i.trim());
                itemdata[0].app_users.map((item: any, index) => {
                    arr.push(item.phone);
                });

                if (!d.every((e: any) => arr.includes(e))) {
                    return false;
                } else {
                    return true;
                }
            }
        }
        return false;
    };

    const dataValidationFn = (records, i, isValid, fn) => {
        const currentDate = moment();
        try {
            if (props.type === 'transporter') {
                if (records?.[i]) {
                    const rec: any = records?.[i];
                    records[i]['errors'] = {};
                    const pickupDate = moment(rec.pickUpDate);
                    const cutOffTime = moment(rec.cutOffTime);
                    const deliveryTime = moment(rec.deliveryDate);

                    // if (!rec.minBidRate || parseFloat(rec?.minBidRate) == 0) {
                    //     isValid = false;
                    //     records[i]['errors']['minBidRate'] = 'Min bid cannot be empty or zero';
                    // }
                    // if (!rec.maxBidRate || parseFloat(rec?.maxBidRate) == 0) {
                    //     isValid = false;
                    //     records[i]['errors']['maxBidRate'] = 'Max bid cannot be empty or zero';
                    // }

                    if (
                        rec?.minBidRate &&
                        rec?.maxBidRate &&
                        parseFloat(rec?.minBidRate) > 0 &&
                        parseFloat(rec?.maxBidRate) > 0 &&
                        parseInt(rec?.minBidRate) > parseInt(rec?.maxBidRate)
                    ) {
                        isValid = false;
                        records[i]['errors']['minBidRate'] = 'Min bid should be less then the max bid';
                    }

                    if (!rec.pickupPincode) {
                        isValid = false;
                        records[i]['errors']['pickupPincode'] = 'Pincode cannot be empty';
                    } else if (rec?.pickupPincode && !pincodes.toString().includes(rec?.pickupPincode)) {
                        isValid = false;
                        records[i]['errors']['pickupPincode'] = 'Pincode does not exists';
                    }

                    if (!rec.pickupCity) {
                        isValid = false;
                        records[i]['errors']['pickupCity'] = 'Pickup city cannot be empty';
                    } else if (rec?.pickupCity && !location.includes(rec?.pickupCity.trim().toLowerCase())) {
                        isValid = false;
                        records[i]['errors']['pickupCity'] = 'Pickup city does not exists';
                    }

                    if (!rec.deliveryPincode) {
                        isValid = false;
                        records[i]['errors']['deliveryPincode'] = 'Pincode cannot be empty';
                    } else if (rec?.deliveryPincode && !pincodes.toString().includes(rec?.deliveryPincode)) {
                        isValid = false;
                        records[i]['errors']['deliveryPincode'] = 'Pincode does not exists';
                    }

                    if (!rec.deliveryCity) {
                        isValid = false;
                        records[i]['errors']['deliveryCity'] = 'Delivery city cannot be empty';
                    } else if (rec?.deliveryCity && !location.includes(rec?.deliveryCity.trim().toLowerCase())) {
                        isValid = false;
                        records[i]['errors']['deliveryCity'] = 'Delivery city does not exists';
                    }

                    if (!rec.weight || parseFloat(rec?.weight) == 0) {
                        isValid = false;
                        records[i]['errors']['weight'] = 'Weight cannot be empty or zero';
                    }

                    if (!rec.noOfVehicles || parseInt(rec?.noOfVehicles) == 0) {
                        isValid = false;
                        records[i]['errors']['noOfVehicles'] = 'No. of vehicle cannot be empty or zero';
                    }

                    if (!rec.itemUnit) {
                        isValid = false;
                        records[i]['errors']['itemUnit'] = 'Unit cannot be empty';
                    } else if (rec?.itemUnit && !unitType.includes(rec?.itemUnit.trim().toLowerCase())) {
                        isValid = false;
                        records[i]['errors']['itemUnit'] = 'Unit does not exists';
                    }

                    if (!rec.status) {
                        isValid = false;
                        records[i]['errors']['status'] = 'Status cannot be empty';
                    } else if (rec?.status && !['active', 'inactive'].includes(rec?.status.trim().toLowerCase())) {
                        isValid = false;
                        records[i]['errors']['status'] = 'Invalid status';
                    }

                    if (!rec.demandType) {
                        isValid = false;
                        records[i]['errors']['demandType'] = 'demandType cannot be empty';
                    } else if (rec?.demandType && !['auto', 'manual'].includes(rec?.demandType.trim().toLowerCase())) {
                        isValid = false;
                        records[i]['errors']['demandType'] = 'Invalid demandType';
                    }

                    if (!rec.materialType) {
                        isValid = false;
                        records[i]['errors']['materialType'] = 'Material type cannot be empty';
                    } else if (rec?.materialType && !materialType.includes(rec?.materialType.trim().toLowerCase())) {
                        isValid = false;
                        records[i]['errors']['materialType'] = 'Material type does not exists';
                    }

                    if (!rec.pickUpDate) {
                        isValid = false;
                        records[i]['errors']['pickUpDate'] = 'Pickup date cannot be empty';
                    } else if (rec?.pickUpDate && moment(rec.pickUpDate).isBefore(currentDate)) {
                        isValid = false;
                        records[i]['errors']['pickUpDate'] = 'Pickup date cannot be past date';
                    } else if (pickupDate.diff(cutOffTime, 'hours') < 2) {
                        isValid = false;
                        records[i]['errors']['pickUpDate'] =
                            'Pickup date should be at least two hours greater than cutOffTime';
                    }

                    if (!rec.deliveryDate) {
                        isValid = false;
                        records[i]['errors']['deliveryDate'] = 'Delivery date cannot be empty';
                    } else if (rec?.deliveryDate && moment(rec.deliveryDate).isBefore(currentDate)) {
                        isValid = false;
                        records[i]['errors']['deliveryDate'] = 'Delivery date cannot be past date';
                    } else if (
                        rec?.pickUpDate &&
                        rec?.deliveryDate &&
                        moment(rec.deliveryDate) < moment(rec.pickUpDate)
                    ) {
                        isValid = false;
                        records[i]['errors']['deliveryDate'] = 'Delivery date should be greater then the pickup date';
                    } else if (deliveryTime.diff(pickupDate, 'hour') < 2) {
                        isValid = false;
                        records[i]['errors']['deliveryDate'] =
                            'deliveryDate date least two hours greater  than pickUpdate time';
                    }

                    if (!rec.cutOffTime) {
                        isValid = false;
                        records[i]['errors']['cutOffTime'] = 'CutOff date cannot be empty';
                    } else if (rec?.cutOffTime && moment(rec.cutOffTime).isBefore(currentDate)) {
                        isValid = false;
                        records[i]['errors']['cutOffTime'] = 'CutOff date cannot be past date';
                    } else if (rec?.pickUpDate && rec?.cutOffTime && moment(rec.pickUpDate) < moment(rec.cutOffTime)) {
                        isValid = false;
                        records[i]['errors']['cutOffTime'] = 'CutOff date should be less then the pickup date';
                    }

                    const users = rec.users;
                    if (!users) {
                        isValid = false;
                        records[i]['errors']['users'] = 'Users cannot be empty';
                    } else if (rec?.users == 'All Transporter') {
                    } else if (rec?.users && users.toString().split(',')?.length > 0) {
                        const d = users
                            .toString()
                            .split(',')
                            .map(i => i.trim());
                        if (!d.every((e: any) => usersData.includes(e))) {
                            isValid = false;
                            records[i]['errors']['users'] = 'Phone no does not exists';
                        }
                    }

                    i++;
                    dataValidationFn(records, i, isValid, fn);
                } else {
                    fn({ records, isValid: isValid });
                }
            } else {
                if (records?.[i]) {
                    const rec: any = records?.[i];
                    records[i]['errors'] = {};
                    const cutOffTime = moment(rec.cutOffTime);
                    const deliveryTime = moment(rec.deliveryDate);
                    if (!rec.minBidRate || parseFloat(rec?.minBidRate) == 0) {
                        isValid = false;
                        records[i]['errors']['minBidRate'] = 'Min bid cannot be empty or zero';
                    }
                    if (!rec.maxBidRate || parseFloat(rec?.maxBidRate) == 0) {
                        isValid = false;
                        records[i]['errors']['maxBidRate'] = 'Max bid cannot be empty or zero';
                    }

                    if (
                        rec?.minBidRate &&
                        rec?.maxBidRate &&
                        parseFloat(rec?.minBidRate) > 0 &&
                        parseFloat(rec?.maxBidRate) > 0 &&
                        parseInt(rec?.minBidRate) > parseInt(rec?.maxBidRate)
                    ) {
                        isValid = false;
                        records[i]['errors']['minBidRate'] = 'Min bid should be less then the max bid';
                    }

                    if (!rec.category) {
                        isValid = false;
                        records[i]['errors']['category'] = 'Category cannot be empty';
                    } else if (rec?.category && checkCategory(rec?.category.trim().toString())) {
                        isValid = false;

                        records[i]['errors']['category'] = 'Category does not exists';
                    }

                    if (!rec.demandType) {
                        isValid = false;
                        records[i]['errors']['demandType'] = 'demandType cannot be empty';
                    } else if (rec?.demandType && !['auto', 'manual'].includes(rec?.demandType.trim().toLowerCase())) {
                        isValid = false;
                        records[i]['errors']['demandType'] = 'Invalid demandType';
                    }

                    if (!rec.item) {
                        isValid = false;
                        records[i]['errors']['item'] = 'Item cannot be empty';
                    } else if (rec?.item && checkItem(rec)) {
                        isValid = false;
                        records[i]['errors']['item'] = 'Item does not exists';
                    }

                    if (!rec.quantity || parseFloat(rec?.quantity) == 0) {
                        isValid = false;
                        records[i]['errors']['quantity'] = 'Quantity cannot be empty or zero';
                    }

                    if (!rec.quality) {
                        isValid = false;
                        records[i]['errors']['quality'] = 'Quality cannot be empty';
                    }

                    if (!rec.itemUnit) {
                        isValid = false;
                        records[i]['errors']['itemUnit'] = 'Item Unit cannot be empty';
                    } else if (rec?.itemUnit && checkUnit(rec)) {
                        isValid = false;
                        records[i]['errors']['itemUnit'] = 'Item Unit does not exists';
                    }

                    if (!rec.deliveryDate) {
                        isValid = false;
                        records[i]['errors']['deliveryDate'] = 'Delivery date cannot be empty';
                    } else if (rec?.deliveryDate && moment(rec.deliveryDate).isBefore(currentDate)) {
                        isValid = false;
                        records[i]['errors']['deliveryDate'] = 'Delivery date cannot be past date';
                    } else if (deliveryTime.diff(cutOffTime, 'hour') < 2) {
                        isValid = false;
                        records[i]['errors']['deliveryDate'] =
                            'deliveryDate date least two hours greater  than cutOff time';
                    }

                    if (!rec.cutOffTime) {
                        isValid = false;
                        records[i]['errors']['cutOffTime'] = 'CutOff date cannot be empty';
                    } else if (rec?.cutOffTime && moment(rec.cutOffTime).isBefore(currentDate)) {
                        isValid = false;
                        records[i]['errors']['cutOffTime'] = 'CutOff date cannot be past date';
                    } else if (rec?.pickUpDate && rec?.cutOffTime && moment(rec.pickUpDate) < moment(rec.cutOffTime)) {
                        isValid = false;
                        records[i]['errors']['cutOffTime'] = 'CutOff date should be less then the pickup date';
                    }

                    const users = rec.users;
                    if (!users) {
                        isValid = false;
                        records[i]['errors']['users'] = 'Users cannot be empty';
                    } else if (rec?.users && users.toString().split(',')?.length > 0) {
                        if (!checkUser(rec)) {
                            isValid = false;
                            records[i]['errors']['users'] = 'Phone no does not exists';
                        }
                    }

                    i++;
                    dataValidationFn(records, i, isValid, fn);
                } else {
                    fn({ records, isValid: isValid });
                }
            }
        } catch (error) {
            fn({ records, isValid: isValid });
        }
    };

    const excelDateToJSDate = (serial: any, format?: string): Date | string => {
        try {
            const baseDate = new Date('1899-12-30');
            const days = Math.floor(serial);
            const millisecondsPerDay = 24 * 60 * 60 * 1000;
            const elapsedMilliseconds = Math.floor((serial - days) * millisecondsPerDay);

            let dated: Date | string = new Date(baseDate.getTime() + days * millisecondsPerDay + elapsedMilliseconds);

            if (format) {
                dated = moment.utc(dated).format(format);
            }

            return dated;
        } catch (error) { }
    };

    const handelModel = (flag: boolean) => {
        try {
            props.setShowHideModel(flag);
        } catch (error) { }
    };

    const itemdata = (item: any, index, value, isDate = false) => {
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                    {item?.errors && Object.keys(item.errors).length > 0 && item?.errors?.[value] ? (
                        <>
                            {isDate ? (
                                <span style={{ color: '#BB0A1E' }}>
                                    {moment(item[value]).format('YYYY/MM/DD HH:mm:ss ')}
                                </span>
                            ) : (
                                <span style={{ color: '#BB0A1E' }}>{item[value]}</span>
                            )}
                        </>
                    ) : (
                        <>
                            {isDate ? (
                                <span>{moment(item[value]).format('YYYY/MM/DD HH:mm:ss ')}</span>
                            ) : (
                                <span>{item[value]}</span>
                            )}
                        </>
                    )}
                    {item?.errors && Object.keys(item.errors).length > 0 && item?.errors?.[value] && (
                        <>
                            <span
                                className="material-symbols-outlined"
                                aria-hidden="true"
                                data-tooltip-id={`my-tooltip-${index}-${value}`}
                                style={{ color: '#BB0A1E', fontSize: '16px', marginLeft: '3px' }}
                            >
                                info
                            </span>
                            <ReactTooltip
                                id={`my-tooltip-${index}-${value}`}
                                place="bottom"
                                content={item?.errors?.[value]}
                                style={{ backgroundColor: '#BB0A1E', color: 'white', marginLeft: '5px' }}
                            />
                        </>
                    )}
                </div>
            </>
        );
    };

    const listLog = list?.map((item: any, index) => {
        return (
            <>
                {props.type === 'transporter' ? (
                    <tr
                        key={index}
                        style={
                            item?.errors && Object.keys(item.errors).length > 0
                                ? { backgroundColor: '#FCF3F4' }
                                : { backgroundColor: 'rgba(0, 131, 62, 0.3)' }
                        }
                    >
                        <td>{index + 2}</td>
                        <td>{itemdata(item, index, 'pickupPincode')}</td>
                        <td>{itemdata(item, index, 'pickupCity')}</td>
                        <td>{itemdata(item, index, 'pickUpDate', true)}</td>
                        <td>{itemdata(item, index, 'deliveryPincode')}</td>
                        <td>{itemdata(item, index, 'deliveryCity')}</td>
                        <td>{itemdata(item, index, 'deliveryDate', true)}</td>
                        <td>{itemdata(item, index, 'users')}</td>
                        <td>{itemdata(item, index, 'cutOffTime', true)}</td>
                        <td>{itemdata(item, index, 'materialType')}</td>
                        <td>{itemdata(item, index, 'weight')}</td>
                        <td>{itemdata(item, index, 'itemUnit')}</td>
                        <td>{itemdata(item, index, 'noOfVehicles')}</td>
                        <td>{itemdata(item, index, 'minBidRate')}</td>
                        <td>{itemdata(item, index, 'maxBidRate')}</td>
                        <td>{itemdata(item, index, 'status')}</td>
                        <td>{itemdata(item, index, 'demandType')}</td>
                        {/* <td>{item.description}</td> */}
                    </tr>
                ) : (
                    <tr
                        key={index}
                        style={
                            item?.errors && Object.keys(item.errors).length > 0
                                ? { backgroundColor: '#FCF3F4' }
                                : { backgroundColor: 'rgba(0, 131, 62, 0.3)' }
                        }
                    >
                        <td>{index + 2}</td>
                        <td>{itemdata(item, index, 'category')}</td>
                        <td>{itemdata(item, index, 'item')}</td>
                        <td>{itemdata(item, index, 'itemUnit')}</td>
                        <td>{itemdata(item, index, 'quantity')}</td>
                        <td>{itemdata(item, index, 'quality')}</td>
                        <td>{itemdata(item, index, 'deliveryDate', true)}</td>
                        <td>{itemdata(item, index, 'users')}</td>
                        <td>{itemdata(item, index, 'cutOffTime', true)}</td>
                        <td>{itemdata(item, index, 'minBidRate')}</td>
                        <td>{itemdata(item, index, 'maxBidRate')}</td>
                        <td>{itemdata(item, index, 'status')}</td>
                        <td>{itemdata(item, index, 'demandType')}</td>
                        {/* <td>{item.description}</td> */}
                    </tr>
                )}
            </>
        );
    });

    const downLoadFile = () => {
        try {
            if (props.type === 'transporter') {
                const data = [
                    {
                        pickupPincode: '303301',
                        pickupCity: 'jaipur',
                        pickUpDate: '2023/12/30 23:00:00',
                        deliveryPincode: '303301',
                        deliveryCity: 'jaipur',
                        deliveryDate: '2023/12/30 23:00:00',
                        cutOffTime: '2023/12/29 23:00:00',
                        users: '8978786767, 7867897878',
                        materialType: 'solid',
                        weight: 204,
                        itemUnit: 'Kilogram',
                        noOfVehicles: 2,
                        minBidRate: 3000,
                        maxBidRate: 3500,
                        description: 'Test Description',
                        status: 'active',
                        demandType: 'manual',
                    },
                    {
                        pickupPincode: '302001',
                        pickupCity: 'jaipur',
                        pickUpDate: '2023/12/30 23:00:00',
                        deliveryPincode: '302001',
                        deliveryCity: 'jaipur',
                        deliveryDate: '2023/12/30 23:00:00',
                        cutOffTime: '2023/12/29 23:00:00',
                        users: 'All Transporter',
                        materialType: 'solid',
                        weight: 204,
                        itemUnit: 'Kilogram',
                        noOfVehicles: 2,
                        minBidRate: 3000,
                        maxBidRate: 3500,
                        description: 'Test Description',
                        status: 'active',
                        demandType: 'manual',
                    },
                ];

                const ws = XLSX.utils.json_to_sheet(data);

                const data2 = [
                    { keyName: 'pickupPincode', Description: 'This is pickup pincode' },
                    { keyName: 'pickupCity', Description: 'This is pickup city' },
                    {
                        keyName: 'pickUpDate',
                        Description:
                            'This is pickup date and should be future date and Date format is 2023/12/21 23:30:00',
                    },
                    { keyName: 'deliveryPincode', Description: 'This is delivery pincode' },
                    { keyName: 'deliveryCity', Description: 'This is delivery city' },
                    {
                        keyName: 'deliveryDate',
                        Description:
                            'This is delivery date and should be future date and Date format is 2023/12/21 22:00:00',
                    },
                    {
                        keyName: 'cutOffTime',
                        Description:
                            'This is date and should be less then pickup date and Date format is 2023/12/21 08:00:00',
                    },
                    {
                        keyName: 'users',
                        Description:
                            'Transporter mobile No. and use "All Transporter" keyword to select all transporter',
                    },
                    { keyName: 'materialType', Description: 'This is type of material like solid, liquid/gas' },
                    { keyName: 'weight', Description: 'This is weight if items like 1 ton, 2 ton' },
                    { keyName: 'itemUnit', Description: 'This is unit like Kilogram, ton etc' },
                    { keyName: 'noOfVehicles', Description: 'Number of vehicle required' },
                    {
                        keyName: 'minBidRate',
                        Description: 'Minimum rate is required like 5000, 7000 this should be less then Max Bid Rate',
                    },
                    {
                        keyName: 'maxBidRate',
                        Description:
                            'Maximum rate is required like 6000, 8000 this should be greater then Min Bid Rate',
                    },
                    { keyName: 'description', Description: 'Description' },
                    { keyName: 'status', Description: 'Status of the demand and can be a "active" and "inactive"' },
                    { keyName: 'demandType', Description: 'Type of the demand and can be a "manual" and "auto"' },
                ];
                const ws2 = XLSX.utils.json_to_sheet(data2);

                // const columns = ["pickupCity", "pickUpDate", "deliveryCity", "deliveryDate", "cutOffTime", "users", "materialType", "weight", "itemUnit", "noOfVehicles", "minBidRate", "maxBidRate", "description"];
                // const ws = XLSX.utils.aoa_to_sheet([columns]);

                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, ws, 'Demands');
                XLSX.utils.book_append_sheet(workbook, ws2, 'Instructions');
                XLSX.writeFile(workbook, 'Sample-File.xlsx');
            } else {
                const data = [
                    {
                        category: 'Wood',
                        item: 'chair',
                        itemUnit: 'Kilogram',
                        quantity: '10',
                        quality: 'avg',
                        deliveryDate: '2023/12/30 23:00:00',
                        cutOffTime: '2023/12/29 23:00:00',
                        users: '8978786767, 7867897878',
                        minBidRate: 3000,
                        maxBidRate: 3500,
                        description: 'Test Description',
                        status: 'active',
                        demandType: 'manual',
                    },
                ];

                const ws = XLSX.utils.json_to_sheet(data);

                const data2 = [
                    { keyName: 'category', Description: 'This is category' },
                    { keyName: 'item', Description: 'This is item' },
                    { keyName: 'itemUnit', Description: 'This is unit like Kilogram, ton etc' },
                    { keyName: 'quantity', Description: 'This is quantity should greater than zero' },
                    { keyName: 'quality', Description: 'This is quality' },
                    {
                        keyName: 'deliveryDate',
                        Description:
                            'This is delivery date and should be future date and Date format is 2023/12/21 21:30:00',
                    },
                    {
                        keyName: 'cutOffTime',
                        Description:
                            'This is date and should be less then pickup date and Date format is 2023/12/21 22:30:00 ',
                    },
                    { keyName: 'users', Description: 'This is users' },
                    {
                        keyName: 'minBidRate',
                        Description: 'Minimum rate is required like 5000, 7000 this should be less then Max Bid Rate',
                    },
                    {
                        keyName: 'maxBidRate',
                        Description:
                            'Maximum rate is required like 6000, 8000 this should be greater then Min Bid Rate',
                    },
                    { keyName: 'description', Description: 'Description' },
                    { keyName: 'status', Description: 'Status of the demand and can be a "active" and "inactive"' },
                    { keyName: 'demandType', Description: 'Type of the demand and can be a "manual" and "auto"' },
                ];
                const ws2 = XLSX.utils.json_to_sheet(data2);

                // const columns = ["pickupCity", "pickUpDate", "deliveryCity", "deliveryDate", "cutOffTime", "users", "materialType", "weight", "itemUnit", "noOfVehicles", "minBidRate", "maxBidRate", "description"];
                // const ws = XLSX.utils.aoa_to_sheet([columns]);

                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, ws, 'Demands');
                XLSX.utils.book_append_sheet(workbook, ws2, 'Instructions');
                XLSX.writeFile(workbook, 'Sample-File.xlsx');
            }
        } catch (error) { }
    };

    function generateRandomID() {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let randomID = '';

        for (let i = 0; i < 7; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            randomID += characters.charAt(randomIndex);
        }

        return randomID;
    }

    const uploadFile = async () => {
        const deepList = JSON.parse(JSON.stringify(list));
        try {
            setDemandStatus('');
            if (props.type === 'transporter') {
                try {
                    handelModel(false);
                    setProgressType(true);

                    const randomId = generateRandomID();
                    localStorage.setItem('randomId', randomId);

                    const formData = new FormData();
                    formData.append('file', upfile);

                    setProgress(true);

                    const updateddata = await APIService.post(`bulk/demand/${randomId}`, formData, true, true);

                    if (updateddata.status === 200) {
                        // Notify("success", "File uploaded successfully");

                        setUploadTrue(false);
                    } else {
                        setProgress(false);
                        handelModel(true);
                        setshowHideUploadBtn(false);
                    }
                } catch (error) {
                    setProgress(false);
                    handelModel(true);
                    setshowHideUploadBtn(false);
                    setListError(deepList, error?.response?.data?.data, 0);
                }
            } else {
                try {
                    setProgressType(false);

                    handelModel(false);
                    setList([]);
                    const randomId = generateRandomID();
                    localStorage.setItem('otherrandomId', randomId);

                    const formData = new FormData();
                    formData.append('file', upfile);

                    setProgress(true);

                    const updateddata = await APIService.post(`bulk/demand/oth/${randomId}`, formData, true, true);

                    if (updateddata.status === 200) {
                        // Notify("success", "File uploaded successfully");

                        setUploadTrue(false);
                    } else {
                        setProgress(false);
                        handelModel(true);
                        setshowHideUploadBtn(false);
                    }
                } catch (error) {
                    setProgress(false);
                    handelModel(true);
                    setshowHideUploadBtn(false);
                    setListError(deepList, error?.response?.data?.data, 0);

                    // setListError()
                }
            }
        } catch (error) { }
    };

    const setListError = (lists, data: any, i) => {
        try {
            if (data?.[i]) {
                const indx = data[i]['index'] - 2;

                if (lists[indx]) {
                    lists[indx]['errors'] = data[i]['error'];
                }
                i++;
                setListError(lists, data, i);
            } else {
                setList(lists);
            }
        } catch (error) { }
    };

    return (
        <>
            {props.showHideModel && (
                <Modal
                    scrollable={true}
                    show={true}
                    onHide={() => {
                        handelModel(false);
                        setUploadTrue(false);
                    }}
                    backdrop="static"
                    keyboard={false}
                    size={uploadTrue ? 'lg' : 'md'}
                    dialogClassName={uploadTrue ? 'modal-width' : 'modal-width-med'}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{uploadTrue ? 'Demand' : 'Bulk Upload'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* Todo Implement loader stucking */}
                        {loaderstate ? (
                            <div className="bulkloader">
                                <p style={{ fontSize: '17px', color: '#03446f' }}>
                                    Loading...{' '}
                                    <span>
                                        <img src="assets/images/dotloading.svg" style={{ width: '26px' }} />
                                    </span>
                                </p>
                                {/* <AiOutlineLoading3Quarters className='animatedloader' style={{ animation: "spin 1s infinite linear" }} /> */}
                            </div>
                        ) : (
                            <div>
                                <input
                                    style={{ display: 'none' }}
                                    type="file"
                                    name="myFile"
                                    className="drop-zone__input"
                                    id="panDoc"
                                    accept=".xlsx, .csv"
                                    onChange={handlefile}
                                />
                                {uploadTrue ? (
                                    <div className="table_box_cover">
                                        <table
                                            className="dataTable display manage_Penalty_table"
                                            style={{ width: '100%' }}
                                        >
                                            <thead>
                                                {props.type === 'transporter' ? (
                                                    <tr>
                                                        <th className="no-sort">SN.</th>
                                                        <th className="no-sort">Pickup Pincode</th>
                                                        <th className="no-sort">Pickup City</th>
                                                        <th className="no-sort">Pickup Date</th>
                                                        <th className="no-sort">Delivery Pincode</th>
                                                        <th className="no-sort">Delivery City</th>
                                                        <th className="no-sort">Delivery Date</th>
                                                        <th className="no-sort">Users</th>
                                                        <th className="no-sort">Cut-off Time</th>
                                                        <th className="no-sort">Material Type</th>
                                                        <th className="no-sort">Weight</th>
                                                        <th className="no-sort">Unit Type</th>
                                                        <th className="no-sort">No. of Vehicle</th>
                                                        <th className="no-sort">Min-Bid</th>
                                                        <th className="no-sort">Max-Bid</th>
                                                        <th className="no-sort">Status</th>
                                                        <th className="no-sort">Demand Type</th>
                                                        {/* <th className="no-sort">Description</th> */}
                                                    </tr>
                                                ) : (
                                                    <tr>
                                                        <th className="no-sort">SN.</th>
                                                        <th className="no-sort">Category</th>
                                                        <th className="no-sort">Items</th>
                                                        <th className="no-sort">Unit</th>
                                                        <th className="no-sort">Quantity</th>

                                                        <th className="no-sort">Quality</th>
                                                        <th className="no-sort">Delivery Date</th>
                                                        <th className="no-sort">Users</th>
                                                        <th className="no-sort">Cut-off Time</th>
                                                        <th className="no-sort">Min-Bid</th>
                                                        <th className="no-sort">Max-Bid</th>
                                                        <th className="no-sort">Status</th>
                                                        <th className="no-sort">Demand Type</th>

                                                        {/* <th className="no-sort">Description</th> */}
                                                    </tr>
                                                )}
                                            </thead>
                                            <tbody>{listLog}</tbody>
                                        </table>
                                        {showHideUploadBtn && uploadTrue ? (
                                            ''
                                        ) : (
                                            <div className="uploadlisterror">
                                                <span style={{ color: '#BB0A1E' }}>
                                                    <span className="material-symbols-outlined">error</span> &nbsp;
                                                    There appears to be an error in the uploaded file. Please review the
                                                    content above for any errors.
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <>
                                        <div className="bulkupload">
                                            <img
                                                src="assets/images/excelicon.svg"
                                                className="img-fluid"
                                                style={{ marginTop: '-16px' }}
                                            />
                                            <div className="browsefile" style={{ paddingTop: '17px' }}>
                                                <button
                                                    className="btn custom_btn unfill_btn with_icon folderopen"
                                                    onClick={() => {
                                                        document.getElementById('panDoc')?.click();
                                                    }}
                                                >
                                                    <span className="material-symbols-outlined">folder_open</span>
                                                    <span
                                                        className="d-flex"
                                                        style={{
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            flexDirection: 'row',
                                                        }}
                                                    >
                                                        <span className="browsetext"> Browse File </span> (.xls, .xlsx
                                                        or .csv){' '}
                                                    </span>
                                                </button>

                                                <p className="sub_box file-size-text">( Max file size 1 MB )</p>
                                            </div>
                                            <span style={{ marginTop: '-22px' }}>
                                                <span className="downloaded_file_link" onClick={downLoadFile}>
                                                    Download Sample File{' '}
                                                </span>
                                                <span>
                                                    <img src="assets/images/dowloadloading.svg" />
                                                </span>
                                            </span>
                                        </div>
                                        <br />
                                        <div className="uploadlist">
                                            <span>
                                                <span className="material-symbols-outlined">error</span> &nbsp;Upload
                                                .xls or .csv file to continue. Please note the followings things before
                                                proceeding further:
                                            </span>
                                            {props.type === 'transporter' ? (
                                                <ol>
                                                    <li>
                                                        Pickup pincode should not be more than six digits (Numeric).
                                                    </li>
                                                    <li>Make sure pickup city spelling is correct.</li>
                                                </ol>
                                            ) : (
                                                <ol>
                                                    <li>Make sure category spelling is correct.</li>
                                                    <li>Make sure item spelling is correct.</li>
                                                    <li>Quantity should be greater than zero (Numeric).</li>
                                                    <li>Make sure unit spelling is correct.</li>
                                                    <li>Make sure registered user no will be present.</li>
                                                </ol>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                    </Modal.Body>
                    {loaderstate ? (
                        ''
                    ) : (
                        <Modal.Footer>
                            {showHideUploadBtn && uploadTrue ? (
                                <Button
                                    variant="secondary"
                                    className="btn dark_btn custom_btn"
                                    onClick={() => {
                                        uploadFile();
                                    }}
                                >
                                    Uploads
                                </Button>
                            ) : (
                                // <Button
                                //     variant="secondary"
                                //     className="btn dark_btn custom_btn"

                                // >
                                //     Add
                                // </Button>

                                ''
                            )}
                            <Button
                                variant="default"
                                className="btn custom_btn border_btn with_icon"
                                onClick={() => {
                                    handelModel(false);
                                    setUploadTrue(false);
                                }}
                            >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    )}
                </Modal>
            )}
        </>
    );
};

export default BulkUpload;
